import { render, staticRenderFns } from "./Personalization.vue?vue&type=template&id=2b546abc&scoped=true"
import script from "./Personalization.vue?vue&type=script&lang=js"
export * from "./Personalization.vue?vue&type=script&lang=js"
import style0 from "./Personalization.vue?vue&type=style&index=0&id=2b546abc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b546abc",
  null
  
)

export default component.exports